import React from 'react';
import { ScrollView, View } from 'react-native';

import TouchableElement from '@components/common/touchableElement';
import NotePreviewItem from './NotePreviewItem';
import ColorWrapper from '@styles/colors';
import NoteContentPreview from './NoteContentPreview';

import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

import { ColorFunction } from '@styles/colors/types';
import { scaleOP } from '@components/frame';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { ODataDocument } from '@v2/components/imageHandling/types/types.d';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { setSelectedNoteId } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

interface NotesPreviewProps {
  notes: ODataDocument[];
  C: ColorFunction;
  scale?: ScaleFunction;
}

const NotesPreview: React.FC<NotesPreviewProps> = ({ notes, C, scale = scaleOP }) => {
  const dispatch = useAppDispatch();

  return (
    <ScrollView
      style={{
        height: '100%',
        width: '100%',
        paddingHorizontal: scale(18),
        backgroundColor: C(`Background/${C.scheme === 'light' ? 'Light' : 'Dark'}/Panel [mobile]`, false),
        paddingBottom: scale(18),
      }}
      contentContainerStyle={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        gap: scale(18),
      }}
    >
      {notes.map((note) => {
        return (
          <TouchableElement key={note.contentHash} onPress={() => dispatch(setSelectedNoteId(note.documentId))}>
            {({ boxStyle }) => {
              return (
                <View
                  style={[
                    boxStyle,
                    {
                      display: 'flex',
                      flexDirection: 'column',
                      gap: scale(9),
                      backgroundColor: C('Background/Light/Field on Panel [mobile]'),
                      borderRadius: scale(SCREEN_BORDER_RADIUS),
                      overflow: 'hidden',
                    },
                  ]}
                >
                  <NotePreviewItem note={note} />
                  <NoteContentPreview note={note} />
                </View>
              );
            }}
          </TouchableElement>
        );
      })}
    </ScrollView>
  );
};

export default ColorWrapper(NotesPreview);
